
import Panel from 'vux/src/components/panel/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Radio from 'vux/src/components/radio/index.vue'

import XHeader from 'vux/src/components/x-header/index.vue'

export default {
components: {
Panel,
Group,
Radio,
XHeader,
},
computed: {
navTitle() {
const title = this.name || ''
return title.length > 14 ? title.substring(0, 14) + '…' : title
}
},
methods: {
goBack: function () {
this.$router.push({ path: '/home?hideTrans=true' })
},
goReturn() {
this.$router.push({ path: '/home?hideTrans=true' });
},
getWordById(index) {
let favorites = {};
favorites.favoritesid = this.$route.query.favoritesid
favorites.index = index
this.$router.push({
path: "/indexFavorites_display",
query: { favorites: favorites },
});
},
recwordCateFirst(bookId) {
this.$ajax.post(this.$api.gettreeUnitListByTotalId, { totalId: this.$route.query.unitId }).then((result) => {
this.totalUnitList = result;
});
},
getFavorites() {
this.$ajax.get(this.$api.getWordAllByFavoriteId + "?favoriteId=" + this.$route.query.favoritesid).then(
(response) => {
this.wordList = response
this.wordIdList = this.wordList.map(obj => obj.id);
if (this.wordList.length == 0) {
this.$toast('当前收藏夹没有收藏过单词');
return false;
}
this.wordinfo = this.wordList[0]
this.getWordByid(this.wordinfo.id)
},
(response) => {
that.$vux.loading.hide();
}
);
},
},
created() {
this.getFavorites();
this.name = this.$route.query.name
this.recwordCateFirst(this.$route.query);
},
data() {
return {
name: '',
book: {},
activeName: '1',
type: "1",
wordList: [],
wordIdList: [],
wordinfo: {},
totalUnitList: [],
footer: {
title: "1111",
url: "http://vux.li",
},
};
},
};



// WEBPACK FOOTER //
// ./src/views/word/favorites/favoritesList.vue